import {useMemo} from 'react';

export function targetKey(type, id) {
    return `${type}:${id}`;
}

export function edgeTargetKey(edge) {
    const t = edge?.target;
    if (t?.type && t?.id != null) return targetKey(t.type, t.id);
    if (edge?.toType && edge?.toId != null) return targetKey(edge.toType, edge.toId);
    return null;
}

/** Confirmed / manual targets are already related and must not be re-linked. */
export function blockedTargetKeys(existingEdges = []) {
    const keys = new Set();
    for (const edge of existingEdges) {
        const isManual = edge?.source === 'manual';
        const isConfirmed = edge?.reviewStatus === 'confirmed';
        if (!isManual && !isConfirmed) continue;
        const key = edgeTargetKey(edge);
        if (key) keys.add(key);
    }
    return keys;
}

/**
 * Blocked keys with a stable identity, so callers can depend on the result
 * even when they receive a freshly built `existingEdges` array each render.
 */
export function useBlockedTargetKeys(existingEdges) {
    const serialized = useMemo(
        () => [...blockedTargetKeys(existingEdges)].sort().join('|'),
        [existingEdges],
    );
    return useMemo(
        () => new Set(serialized ? serialized.split('|') : []),
        [serialized],
    );
}

export function suggestedEdgeForTarget(existingEdges, type, id) {
    return (existingEdges || []).find((edge) => {
        if (edge?.source === 'manual' || edge?.reviewStatus !== 'suggested') return false;
        return edgeTargetKey(edge) === targetKey(type, id);
    });
}
